import {GatewayError} from '@gravity-ui/gateway';

export function shouldShowError(error: GatewayError) {
    switch (error.status) {
        // not showing error for the 400 and 409 status codes
        // since it's not really an issue with a server
        case 400:
        case 409:
            return false;
        default:
            return true;
    }
}
